export const CardPointeCnpTokenSaleOutcome = {
    APPROVED: 'approved',
    DECLINED: 'declined',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CardPointeCnpTokenSaleOutcome =
    (typeof CardPointeCnpTokenSaleOutcome)[keyof typeof CardPointeCnpTokenSaleOutcome];

interface CardPointeCnpTokenSaleRequestBodyBase {
    readonly merchid: string;
    readonly account: string;
    readonly amount: string;
    readonly currency: string;
    readonly capture: 'y' | 'n';
    readonly ecomind: 'T' | 'E';
    readonly orderid?: string;
    readonly name?: string;
    readonly expiry?: string;
    readonly address?: string;
    readonly city?: string;
    readonly region?: string;
    readonly country?: string;
    readonly postal?: string;
}

export type CardPointeCnpTokenSaleRequestBody =
    | (CardPointeCnpTokenSaleRequestBodyBase & {
          readonly cof?: never;
          readonly cofscheduled?: never;
      })
    | (CardPointeCnpTokenSaleRequestBodyBase & {
          readonly cof: 'C';
          readonly cofscheduled: 'N';
      })
    | (CardPointeCnpTokenSaleRequestBodyBase & {
          readonly cof: 'M';
          readonly cofscheduled: 'N';
      })
    | (CardPointeCnpTokenSaleRequestBodyBase & {
          readonly cof: 'M';
          readonly cofscheduled: 'Y';
      });

export interface CardPointeCnpTokenSaleRequestDetails {
    readonly method: 'PUT';
    readonly path: '/cardconnect/rest/auth';
    readonly body: CardPointeCnpTokenSaleRequestBody;
}

export interface CardPointeCnpTokenSaleAuthorizationBody {
    readonly respstat: 'A' | 'B' | 'C';
    readonly amount?: string;
    readonly resptext?: string;
    readonly authcode?: string;
    readonly respcode?: string;
    readonly merchid?: string;
    readonly cvvresp?: string;
    readonly retref?: string;
    readonly avsresp?: string;
    readonly respproc?: string;
    readonly batchid?: string;
    readonly token?: string;
    readonly account?: string;
    readonly expiry?: string;
    readonly name?: string;
    readonly entrymode?: string;
    readonly bintype?: string;
    readonly commcard?: string;
    readonly orderid?: string;
    readonly cof?: 'C' | 'M';
    readonly fee_amount?: string;
    readonly fee_type?: 'SURCHRG' | 'SURCHRG_WAIVED';
    readonly fee_value?: string;
    readonly fee_format?: 'percent' | '';
    readonly fee_authcode?: string;
    readonly fee_merchid?: string;
    readonly fee_retref?: string;
}

export interface CardPointeCnpTokenSaleApprovedBody extends CardPointeCnpTokenSaleAuthorizationBody {
    readonly respstat: 'A';
    readonly retref: string;
    readonly amount: string;
    readonly merchid: string;
}

export interface CardPointeCnpTokenSaleDeclinedBody extends CardPointeCnpTokenSaleAuthorizationBody {
    readonly respstat: 'B' | 'C';
    readonly resptext: string;
}

export interface CardPointeCnpTokenSaleApprovedResponseDetails {
    readonly outcome: typeof CardPointeCnpTokenSaleOutcome.APPROVED;
    readonly httpStatus: 200;
    readonly body: CardPointeCnpTokenSaleApprovedBody;
}

export interface CardPointeCnpTokenSaleDeclinedResponseDetails {
    readonly outcome: typeof CardPointeCnpTokenSaleOutcome.DECLINED;
    readonly httpStatus: 200;
    readonly body: CardPointeCnpTokenSaleDeclinedBody;
}

export interface CardPointeCnpTokenSaleMalformedResponseDetails {
    readonly outcome: typeof CardPointeCnpTokenSaleOutcome.MALFORMED_RESPONSE;
    readonly httpStatus: number;
    readonly body: unknown;
    readonly message: string;
}

export type CardPointeCnpTokenSaleResponseDetails =
    | CardPointeCnpTokenSaleApprovedResponseDetails
    | CardPointeCnpTokenSaleDeclinedResponseDetails
    | CardPointeCnpTokenSaleMalformedResponseDetails;
